export default __webpack_public_path__ + "static/media/familia1.ea6bc7d2.png";